import { BlockUI, NgBlockUI }              from 'ng-block-ui';
import { Component } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { NgbActiveModal }                  from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }                from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { MessagesService } from '../messages/messages.service';
import { STATUSCODES }     from '../api/api.status-codes.constant';


@Component({
  selector   : 'wor-sync-myob',
  template: require('./myob.sync.component.html')
})
export class SyncMyobComponent {
  private _STATUSCODES = STATUSCODES;
  public isSyncing     = false;

  @BlockUI('syncMyobBlock') public block : NgBlockUI;

  constructor (
    private activeModal     : NgbActiveModal,
    private apiService      : ApiService,
    private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  sync () : void {
    this.block.start();

    this.apiService.get('myob/sync', undefined, undefined, { verbose: true })
    .then(( response : HttpResponse<any> ) => {
      this.activeModal.close(response.body);
    })
    .catch(( error : HttpErrorResponse ) => {
      if (error.status === this._STATUSCODES.timeout) {

        this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.SYNC_STARTED_SUCCESSFULLY', { name: 'MYOB' }), 'success');

        this.activeModal.dismiss();

      }
      else {
        this.messagesService.error(error.error);
      }
    })
    .finally(() => {
      this.block.stop();
    });
  }
}
